import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { PhotoLibraryPage } from '@/features/marketing/google-ranking/photo-library/photo-library-page';
import { toPhotoLibraryPillTab, type PhotoLibraryPillTab } from '@/features/marketing/google-ranking/photo-library/photo-library-format';

type PhotoLibrarySearch = { tab?: Exclude<PhotoLibraryPillTab, 'ready'> };

/**
 * Marketing › Google Ranking › Photo library. A sibling of the Google Ranking tabs route (not nested: the
 * library has its own header with "‹ Posts & photos" instead of the tab bar). Only a non-default tab lives
 * in the URL (`?tab=google` / `?tab=skipped`), so links can open the Skipped photos directly.
 */
export const Route = createFileRoute('/_auth/$orgId/marketing/google-ranking_/photos')({
  validateSearch: (search: Record<string, unknown>): PhotoLibrarySearch => {
    const tab = toPhotoLibraryPillTab(search.tab);
    return { tab: tab === 'ready' ? undefined : tab };
  },
  component: PhotoLibraryRoute,
});

function PhotoLibraryRoute() {
  const { orgId } = Route.useParams();
  const { tab } = Route.useSearch();
  const navigate = useNavigate({ from: '/$orgId/marketing/google-ranking/photos' });

  return (
    <PhotoLibraryPage
      routeOrgId={orgId}
      tab={tab ?? 'ready'}
      onSelectTab={(next) => navigate({ search: { tab: next === 'ready' ? undefined : next }, replace: true })}
    />
  );
}
